<div class="mobile-header-bar d-lg-none d-flex align-items-center">
  <a class="mobile-header-back-btn" [routerLink]="[link]">
    <i class="material-icons">arrow_back_ios</i>
    <h5 class="mobile-header-title" [class.centered]="!showPoints">{{ title }}</h5>
  </a>
</div>
